import React from 'react'
import { Link } from 'react-router-dom'

import styles from './ListItem.module.css'

const ListItem = ({ item, columns, routeName }) => {
  return (
    <tr>
      {columns.map((col, i) => {
        return col.isLink ? (
          <td key={i}>
            <Link to={`/admin/${routeName}/${item.id}`}>{col.value(item)}</Link>
          </td>
        ) : col.onClick ? (
          <td
            key={i}
            className={styles.onClickTd}
            onClick={() => col.onClick(item)}
          >
            {col.value(item)}
          </td>
        ) : (
          <td key={i}>{col.value(item)}</td>
        )
      })}
    </tr>
  )
}

export default ListItem
